module.exports = __webpack_public_path__ + "static/003.thumb-68d06b61d1071d4977e07928516c5552.jpg";